(function () {

    function init() {
        trackOxfordAbstractsClicks();
        trackMoreReadsClicks();
        trackTopicListingClicks();
        trackAuth0LoginEvent();
        trackAdClicks();
        trackPaywallHit();
    }
    // Oxford Abstracts 
    function trackOxfordAbstractsClicks() {
        var links = document.querySelectorAll('a[href*="oxfordabstracts.com"]');
        links.forEach(function (link) {
            link.addEventListener('click', function () {
                if (typeof gtag === 'function' && window.hasAnalyticsConsent && window.hasAnalyticsConsent()) {
                    gtag('event', 'submission_click', {
                        'destination': 'oxford_abstracts'
                    });
                }
            });
        });
    }

    // More Reads
    function trackMoreReadsClicks() {
        var links = document.querySelectorAll('.grid-listing.read-more .card-title a');
        links.forEach(function (link) {
            link.addEventListener('click', function () {
                if (typeof gtag === 'function' && window.hasAnalyticsConsent && window.hasAnalyticsConsent()) {
                    gtag('event', 'module_click', {
                        'module_name': 'More Reads',
                        'clicked_url': this.href
                    });
                }
            });
        });
    }

    // Topic Listing
    function trackTopicListingClicks() {
        var links = document.querySelectorAll('.tags-detailPage .grid-listing .card-title a');
        links.forEach(function (link) {
            link.addEventListener('click', function () {
                if (typeof gtag === 'function' && window.hasAnalyticsConsent && window.hasAnalyticsConsent()) {
                    gtag('event', 'module_click', {
                        'module_name': 'Topic Tile',
                        'clicked_url': this.href
                    });
                }
            });
        });
    }
    // SSO login users
    function getStorageValue(key) {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            return null;
        }
    }

    function setStorageValue(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            // ignore storage failures
        }
    }

    function removeStorageValue(key) {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            // ignore storage failures
        }
    }

    function trackAuth0LoginEvent() {
        var storageKey = 'sor_auth0_user_id';

        if (!window.SiteInfo || !SiteInfo.User) {
            removeStorageValue(storageKey);
            return;
        }

        var currentUserId = SiteInfo.User.Id;
        if (!currentUserId) {
            removeStorageValue(storageKey);
            return;
        }

        var previousUserId = getStorageValue(storageKey);
        if (previousUserId === currentUserId) {
            return;
        }

        var payload = {
            'method': 'Auth0_SSO'
        };

        var role = SiteInfo.User.Role;
        if (role) {
            payload.user_type = role;
        }

        if (typeof gtag === 'function' && window.hasAnalyticsConsent && window.hasAnalyticsConsent()) {
            gtag('event', 'login', payload);
        }

        setStorageValue(storageKey, currentUserId);
    }
    // ads clicks
    function trackAdClicks() {
        var adLinks = document.querySelectorAll('.ad-link');

        adLinks.forEach(function (link) {
            link.addEventListener('click', function () {
                var adType = this.getAttribute('data-ad-type');
                var adUrl = this.getAttribute('data-ad-url');

                if (typeof gtag === 'function' && window.hasAnalyticsConsent && window.hasAnalyticsConsent()) {
                    gtag('event', 'ad_click', {
                        'ad_type': adType,   
                        'ad_destination': adUrl,    
                        'page_location': window.location.href  
                    });
                }
            });
        });
    }
    //restricted articles
    function trackPaywallHit() {
        var articleSection = document.getElementById('articleDetail');

        if (!articleSection) return;

        var isRestricted = articleSection.getAttribute('data-is-restricted');
        if (!isRestricted) return;

        var articleTitle = articleSection.getAttribute('data-article-title') || '';
        var articleCategory = articleSection.getAttribute('data-article-category') || 'Uncategorised';

        if (typeof gtag === 'function' && window.hasAnalyticsConsent && window.hasAnalyticsConsent()) {
            gtag('event', 'paywall_hit', {
                'article_title': articleTitle,
                'article_category': articleCategory,
                'paywall_status': 'restricted_view'
            });
        }
    }

    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', init)
        : init();

})();